export default __webpack_public_path__ + "static/media/creatingPosts.5e4233f2.png";